// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1oSdv","footer":"ModalInfo_footer__1-A_h"};